/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import {
  NbIconLibraries,
  NbMediaBreakpointsService,
  NbThemeService,
} from "@nebular/theme";
import { AnalyticsService } from "app/@core/utils/analytics.service";
import { map } from "rxjs/operators";
import { environment } from "../environments/environment";
import { SvgIcons } from "./svg";

@Component({
  standalone: true,
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
  imports: [RouterModule],
})
export class AppComponent implements OnInit {
  private analytics = inject(AnalyticsService);
  private iconLibraries = inject(NbIconLibraries);
  private breakpointService = inject(NbMediaBreakpointsService);
  private themeService = inject(NbThemeService);

  constructor() {
    this.iconLibraries.registerSvgPack("mirasee", SvgIcons);
  }

  ngOnInit(): void {
    if (environment.gtm) {
      this.analytics.trackPageViews();
    }
    const { md } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(map(([, currentBreakpoint]) => currentBreakpoint.width < md))
      .subscribe((isLessThanMd: boolean) => {
        if (isLessThanMd) {
          this.themeService.changeTheme("miraseemobile");
        } else {
          this.themeService.changeTheme("mirasee");
        }
      });
  }
}
